import React from 'react';
import { Fab, Typography } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

interface WhatsAppFixedButtonProps {
}

const WhatsAppFixedButton: React.FC<WhatsAppFixedButtonProps> = ({ }) => {
    return (
        <Fab onClick={() => window.open(`https://wa.me/38763262122`)} aria-label="whatsapp"
            sx={(theme) => ({
                position: "fixed",
                bottom: 16,
                right: 16,
                backgroundColor: "#111111b2",
                ...theme.applyStyles("dark", {
                    backgroundColor: "#111111b2"
                })
            })}>
            <WhatsAppIcon sx={{ color: "#25D366" }} />
        </Fab>
    )
}

export default WhatsAppFixedButton;